// ./src/hooks/useDeadlineFollowsEnd.ts
//
// ROADMAP #137 review — keeps an RSVP / ticket deadline that sits EXACTLY at the event's (a date's) end on that end when
// the dates move (`deadlineFollowingCeiling`, @em/utils). The deadline is capped at the end to the minute, and picking
// the event's own day lands it there — so without this, moving the end even a minute earlier would be refused at save.
// ⓘ Reads the previous cap from a ref updated on every run, so a run caused by anything else (the deadline itself, a new
// `apply`) compares the cap with itself and changes nothing; a form loading its record moves the cap from null — no-op.
import { useEffect, useRef } from 'react';

import { deadlineFollowingCeiling } from '@em/utils';

export const useDeadlineFollowsEnd = (ceiling: string | null, deadline: string | null, apply: (next: string) => void): void => {
  const prevCeiling = useRef(ceiling);

  useEffect(() => {
    const before = prevCeiling.current;
    prevCeiling.current = ceiling;
    const next = deadlineFollowingCeiling(deadline, before, ceiling);

    if (next && next !== deadline) {
      apply(next);
    }
  }, [ceiling, deadline, apply]);
};
